import './prizes-teaser.scss';

import Swiper from 'swiper';
import { A11y, Pagination } from 'swiper/modules';

class PrizesTeaser {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-prizesteaser',
            sliderAttr: 'slider',
            slideAttr: 'slide'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$prizesTeaser = $element;
        this.$prizesTeaserContainer = this.$prizesTeaser.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$prizesTeaserSlides = this.$prizesTeaser.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);
        this.$prizesModals = this.$prizesTeaser.querySelectorAll('[data-modaltarget]');
        this.prizesTeaserSlider = null;

        const $body = document.body;
        this.$prizesModals.forEach(($modal) => {
            $body.appendChild($modal);
        });

        if (this.$prizesTeaserContainer && this.$prizesTeaserSlides.length > 1) {
            this.initialize();
        }
    }

    initialize () {
        this.checkSize();
        this.setEvents();
    }

    checkSize () {
        if (window.mediaMatchHandler[1024].matches && this.$prizesTeaserSlides.length <= 3) {
            if (this.prizesTeaserSlider !== null) {
                this.destroySlider();
            }
        } else if (window.mediaMatchHandler[600].matches && this.$prizesTeaserSlides.length <= 2) {
            if (this.prizesTeaserSlider !== null) {
                this.destroySlider();
            }
        } else if (window.mediaMatchHandler[320].matches && this.$prizesTeaserSlides.length < 2) {
            if (this.prizesTeaserSlider !== null) {
                this.destroySlider();
            }
        } else {
            if (this.prizesTeaserSlider === null) {
                this.initSlider();
            }
        }
    }

    setEvents () {
        [1024, 600, 320].forEach((bp) => {
            window.mediaMatchHandler[bp].addEventListener('change', () => {
                this.checkSize();
            });
        });
    }

    initSlider () {
        this.prizesTeaserSlider = new Swiper(this.$prizesTeaserContainer, {
            modules: [Pagination, A11y],
            speed: 500,
            slidesPerView: 'auto',
            centeredSlides: true,
            centeredSlidesBounds: true,
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide',
                paginationBulletMessage: 'Springe zu Slide {{index}}',
                firstSlideMessage: 'Dies ist der Erste Slide',
                lastSlideMessage: 'Dies ist der Letzte Slide',
                slideLabelMessage: 'Slide {{index}} von {{slidesLength}}'
            },
            pagination: {
                el: '.swiper-pagination'
            }
        });
    }

    destroySlider () {
        if (this.prizesTeaserSlider !== null) {
            this.prizesTeaserSlider.destroy(true, true);
            this.prizesTeaserSlider = null;
        }
    }
}

export { PrizesTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$prizesTeaser = $context.querySelectorAll('[data-prizesteaser="root"]');
        for (let i = 0; i < $$prizesTeaser.length; i++) {
            const $prizesTeaser = $$prizesTeaser[i];

            const prizesTeaserAPI = new PrizesTeaser($prizesTeaser);
            $prizesTeaser.API = prizesTeaserAPI;
        }
    }
});
